export class KanbamFiltro {

    public quantidade: number = 0;

    constructor(
        public key: KanbanFiltroKey,
        public nome: string,
        public cor: string,
        public ativo: boolean = true
    ) {
    }

}

export type KanbanFiltroKey = "TODOS" | "AGENDAMENTO" | "DELIVERY" | "RETIRADA" | "CONSUMO";